var map = {
	"./40k_logo.png": 143,
	"./DOW_LOGO_BG.png": 144,
	"./DOW_LOGO_FORUMS.png": 145,
	"./ESRB_rating_pending.jpg": 146,
	"./Gwlogo.png": 147,
	"./Gwlogo2.png": 148,
	"./P28 -  LavaBridge -SolariaGabriel copy.jpg": 149,
	"./P28 -  TempleApproach -BigBattleEngagement.jpg": 150,
	"./P28 - TempleApproach - Call to Arms copy.jpg": 151,
	"./P28 - TempleApproach - Drop Pod Assault 02.jpg": 152,
	"./P28 - TempleApproach - LasCannons.jpg": 153,
	"./P28 - TempleApproach - Orbital bombardment II copy.jpg": 154,
	"./Profile_Elite_Overlay.png": 155,
	"./Profile_Pic_Overlay.png": 156,
	"./Profile_Pic_Overlay_1.png": 157,
	"./Profile_Pic_Overlay_2.png": 158,
	"./Profile_Pic_Overlay_3.png": 159,
	"./SEQ002_KeyArt_Final_v02_lowrez.jpg": 160,
	"./age-gate-bg-1024.jpg": 161,
	"./age-gate-bg-1024.webp": 162,
	"./age-gate-bg-1024.webp.png": 163,
	"./age-gate-bg-1080.jpg": 164,
	"./age-gate-bg-1080.webp": 165,
	"./age-gate-bg-1080.webp.png": 166,
	"./age-gate-bg-320.jpg": 167,
	"./age-gate-bg-320.webp": 168,
	"./age-gate-bg-320.webp.png": 169,
	"./age-gate-bg-420.jpg": 170,
	"./age-gate-bg-420.webp": 171,
	"./age-gate-bg-420.webp.png": 172,
	"./age-gate-bg-768.jpg": 173,
	"./age-gate-bg-768.webp": 174,
	"./age-gate-bg-768.webp.png": 175,
	"./ajax-loader.gif": 176,
	"./arrow-down.png": 177,
	"./arrow-right.png": 178,
	"./arrow-up.png": 179,
	"./avatar.jpg": 180,
	"./banner_frame.png": 181,
	"./banner_frame_1.png": 182,
	"./banner_frame_moderator.png": 183,
	"./banner_frame_moderator_1.png": 184,
	"./banner_frame_staff.png": 185,
	"./banner_frame_staff_1.png": 186,
	"./banner_frame_staff_2.png": 187,
	"./banner_frame_staff_3.png": 188,
	"./bg_img_1920x1400.png": 189,
	"./bg_line_pattern.png": 190,
	"./bg_line_pattern_shade.png": 191,
	"./border-icon.png": 192,
	"./burger.png": 193,
	"./buy-bg.jpg": 194,
	"./call_your_elites-1024.jpg": 195,
	"./call_your_elites-1024.webp": 196,
	"./call_your_elites-1024.webp.png": 197,
	"./call_your_elites-1050.jpg": 198,
	"./call_your_elites-1050.webp": 199,
	"./call_your_elites-1050.webp.png": 200,
	"./call_your_elites-320.jpg": 201,
	"./call_your_elites-320.webp": 202,
	"./call_your_elites-320.webp.png": 203,
	"./call_your_elites-420.jpg": 204,
	"./call_your_elites-420.webp": 205,
	"./call_your_elites-420.webp.png": 206,
	"./call_your_elites-768.jpg": 207,
	"./call_your_elites-768.webp": 208,
	"./call_your_elites-768.webp.png": 209,
	"./carousel-1.png": 210,
	"./collosal_battles-320.jpg": 211,
	"./collosal_battles-320.webp": 212,
	"./collosal_battles-320.webp.png": 213,
	"./collosal_battles-420.jpg": 214,
	"./collosal_battles-420.webp": 215,
	"./collosal_battles-420.webp.png": 216,
	"./collosal_battles-768.jpg": 217,
	"./collosal_battles-768.webp": 218,
	"./collosal_battles-768.webp.png": 219,
	"./collosal_battles-872.jpg": 220,
	"./collosal_battles-872.webp": 221,
	"./collosal_battles-872.webp.png": 222,
	"./colossal_clashes-320.jpg": 223,
	"./colossal_clashes-320.webp": 224,
	"./colossal_clashes-320.webp.png": 225,
	"./colossal_clashes-420.jpg": 226,
	"./colossal_clashes-420.webp": 227,
	"./colossal_clashes-420.webp.png": 228,
	"./colossal_clashes-768.jpg": 229,
	"./colossal_clashes-768.webp": 230,
	"./colossal_clashes-768.webp.png": 231,
	"./colossal_clashes-872.jpg": 232,
	"./colossal_clashes-872.webp": 233,
	"./colossal_clashes-872.webp.png": 234,
	"./crests.png": 235,
	"./crests_1.png": 236,
	"./critical-strike-video-poster.jpg": 237,
	"./critical-strike.png": 238,
	"./desktop_footer_h380.png": 239,
	"./desktop_newsletter_bg_h365.png": 240,
	"./desktop_top_keyart_h1920.png": 241,
	"./destructive_abilities-1024.jpg": 242,
	"./destructive_abilities-1024.webp": 243,
	"./destructive_abilities-1024.webp.png": 244,
	"./destructive_abilities-1050.jpg": 245,
	"./destructive_abilities-1050.webp": 246,
	"./destructive_abilities-1050.webp.png": 247,
	"./destructive_abilities-320.jpg": 248,
	"./destructive_abilities-320.webp": 249,
	"./destructive_abilities-320.webp.png": 250,
	"./destructive_abilities-420.jpg": 251,
	"./destructive_abilities-420.webp": 252,
	"./destructive_abilities-420.webp.png": 253,
	"./destructive_abilities-768.jpg": 254,
	"./destructive_abilities-768.webp": 255,
	"./destructive_abilities-768.webp.png": 256,
	"./dirty-fightin-video-poster.jpg": 257,
	"./dow3_logo.png": 258,
	"./eldar-320.jpg": 259,
	"./eldar-320.webp": 260,
	"./eldar-320.webp.png": 261,
	"./eldar-420.jpg": 262,
	"./eldar-420.webp": 263,
	"./eldar-420.webp.png": 264,
	"./eldar-660.jpg": 265,
	"./eldar-660.webp": 266,
	"./eldar-660.webp.png": 267,
	"./eldar-vignette-preview-320.jpg": 268,
	"./eldar-vignette-preview-320.webp": 269,
	"./eldar-vignette-preview-320.webp.png": 270,
	"./eldar-vignette-preview-420.jpg": 271,
	"./eldar-vignette-preview-420.webp": 272,
	"./eldar-vignette-preview-420.webp.png": 273,
	"./eldar-vignette-preview-460.jpg": 274,
	"./eldar-vignette-preview-460.webp": 275,
	"./eldar-vignette-preview-460.webp.png": 276,
	"./esrb-store-footer.png": 277,
	"./eye.png": 278,
	"./faction_bg.png": 279,
	"./faction_campaign_1-320.jpg": 280,
	"./faction_campaign_1-320.webp": 281,
	"./faction_campaign_1-320.webp.png": 282,
	"./faction_campaign_1-420.jpg": 283,
	"./faction_campaign_1-420.webp": 284,
	"./faction_campaign_1-420.webp.png": 285,
	"./faction_campaign_1-660.jpg": 286,
	"./faction_campaign_1-660.webp": 287,
	"./faction_campaign_1-660.webp.png": 288,
	"./faction_campaign_2-320.jpg": 289,
	"./faction_campaign_2-320.webp": 290,
	"./faction_campaign_2-320.webp.png": 291,
	"./faction_campaign_2-420.jpg": 292,
	"./faction_campaign_2-420.webp": 293,
	"./faction_campaign_2-420.webp.png": 294,
	"./faction_campaign_2-660.jpg": 295,
	"./faction_campaign_2-660.webp": 296,
	"./faction_campaign_2-660.webp.png": 297,
	"./faction_campaign_3-320.jpg": 298,
	"./faction_campaign_3-320.webp": 299,
	"./faction_campaign_3-320.webp.png": 300,
	"./faction_campaign_3-420.jpg": 301,
	"./faction_campaign_3-420.webp": 302,
	"./faction_campaign_3-420.webp.png": 303,
	"./faction_campaign_3-660.jpg": 304,
	"./faction_campaign_3-660.webp": 305,
	"./faction_campaign_3-660.webp.png": 306,
	"./favicon.ico": 307,
	"./favicon.png": 308,
	"./favicons/apple_touch_icon_114x114.png": 309,
	"./favicons/apple_touch_icon_57x57.png": 310,
	"./favicons/apple_touch_icon_72x72.png": 311,
	"./favicons/favicon.ico": 312,
	"./favicons/favicon_32x32.png": 313,
	"./flag-sprite.png": 314,
	"./forum-border-ornament.png": 315,
	"./gabriel-icon.png": 316,
	"./gabriel-main-1024.jpg": 317,
	"./gabriel-main-1024.webp": 318,
	"./gabriel-main-1024.webp.png": 319,
	"./gabriel-main-1080.jpg": 320,
	"./gabriel-main-1080.webp": 321,
	"./gabriel-main-1080.webp.png": 322,
	"./gabriel-main-320.jpg": 323,
	"./gabriel-main-320.webp": 324,
	"./gabriel-main-320.webp.png": 325,
	"./gabriel-main-420.jpg": 326,
	"./gabriel-main-420.webp": 327,
	"./gabriel-main-420.webp.png": 328,
	"./gabriel-main-768.jpg": 329,
	"./gabriel-main-768.webp": 330,
	"./gabriel-main-768.webp.png": 331,
	"./gabriel-panel-1024.jpg": 332,
	"./gabriel-panel-1024.webp": 333,
	"./gabriel-panel-1024.webp.png": 334,
	"./gabriel-panel-1050.jpg": 335,
	"./gabriel-panel-1050.webp": 336,
	"./gabriel-panel-1050.webp.png": 337,
	"./gabriel-panel-1080.jpg": 338,
	"./gabriel-panel-1080.webp": 339,
	"./gabriel-panel-1080.webp.png": 340,
	"./gabriel-panel-320.jpg": 341,
	"./gabriel-panel-320.webp": 342,
	"./gabriel-panel-320.webp.png": 343,
	"./gabriel-panel-420.jpg": 344,
	"./gabriel-panel-420.webp": 345,
	"./gabriel-panel-420.webp.png": 346,
	"./gabriel-panel-768.jpg": 347,
	"./gabriel-panel-768.webp": 348,
	"./gabriel-panel-768.webp.png": 349,
	"./gabriel-panel-large.jpg": 350,
	"./god-splitter-video-poster.jpg": 351,
	"./god-splitter.png": 352,
	"./gorgutz-icon.png": 353,
	"./gorgutz-main-1024.jpg": 354,
	"./gorgutz-main-1024.webp": 355,
	"./gorgutz-main-1024.webp.png": 356,
	"./gorgutz-main-1080.jpg": 357,
	"./gorgutz-main-1080.webp": 358,
	"./gorgutz-main-1080.webp.png": 359,
	"./gorgutz-main-320.jpg": 360,
	"./gorgutz-main-320.webp": 361,
	"./gorgutz-main-320.webp.png": 362,
	"./gorgutz-main-420.jpg": 363,
	"./gorgutz-main-420.webp": 364,
	"./gorgutz-main-420.webp.png": 365,
	"./gorgutz-main-768.jpg": 366,
	"./gorgutz-main-768.webp": 367,
	"./gorgutz-main-768.webp.png": 368,
	"./gorgutz-panel-1024.jpg": 369,
	"./gorgutz-panel-1024.webp": 370,
	"./gorgutz-panel-1024.webp.png": 371,
	"./gorgutz-panel-1080.jpg": 372,
	"./gorgutz-panel-1080.webp": 373,
	"./gorgutz-panel-1080.webp.png": 374,
	"./gorgutz-panel-320.jpg": 375,
	"./gorgutz-panel-320.webp": 376,
	"./gorgutz-panel-320.webp.png": 377,
	"./gorgutz-panel-420.jpg": 378,
	"./gorgutz-panel-420.webp": 379,
	"./gorgutz-panel-420.webp.png": 380,
	"./gorgutz-panel-768.jpg": 381,
	"./gorgutz-panel-768.webp": 382,
	"./gorgutz-panel-768.webp.png": 383,
	"./grapplin-klaw-video-poster.jpg": 384,
	"./humble-bundle-logo-only.png": 385,
	"./humble-bundle-logo.png": 386,
	"./humble-bundle-no-logo.png": 387,
	"./icon-arrow.png": 388,
	"./image-border.png": 389,
	"./image_vid_H_1100px.jpg": 390,
	"./img_AGE_GATE_BG.jpg": 391,
	"./img_COLOSSAL_CLASHES_W_2040px_H_872px.jpg": 392,
	"./img_ELDAR_EXPANDED_W_1200px_H_660px.jpg": 393,
	"./img_ELDAR_W_633px_H_660px.jpg": 394,
	"./img_ORK_EXPANDED_W_1200px_H_660px.jpg": 395,
	"./img_ORK_W_639px_H_660px.jpg": 396,
	"./img_SM_EXPANDED_W_1200px_H_660px.jpg": 397,
	"./img_SM_W_639px_H_660px.jpg": 398,
	"./img_UNLEASH_TITANS_W_2040px_H_872px.jpg": 399,
	"./img_featurette_H460px.png": 400,
	"./img_rp_rating.png": 401,
	"./img_war_has_a_price_H1050px.png": 402,
	"./inner-ornament.png": 403,
	"./intro-panel-texture-1024.jpg": 404,
	"./intro-panel-texture-1024.webp": 405,
	"./intro-panel-texture-1024.webp.png": 406,
	"./intro-panel-texture-1080.jpg": 407,
	"./intro-panel-texture-1080.webp": 408,
	"./intro-panel-texture-1080.webp.png": 409,
	"./intro-panel-texture-320.jpg": 410,
	"./intro-panel-texture-320.webp": 411,
	"./intro-panel-texture-320.webp.png": 412,
	"./intro-panel-texture-420.jpg": 413,
	"./intro-panel-texture-420.webp": 414,
	"./intro-panel-texture-420.webp.png": 415,
	"./intro-panel-texture-768.jpg": 416,
	"./intro-panel-texture-768.webp": 417,
	"./intro-panel-texture-768.webp.png": 418,
	"./intro-panel-texture.png": 419,
	"./key-art-1024.jpg": 420,
	"./key-art-1024.webp": 421,
	"./key-art-1024.webp.png": 422,
	"./key-art-1080.jpg": 423,
	"./key-art-1080.webp": 424,
	"./key-art-1080.webp.png": 425,
	"./key-art-320.jpg": 426,
	"./key-art-320.webp": 427,
	"./key-art-320.webp.png": 428,
	"./key-art-420.jpg": 429,
	"./key-art-420.webp": 430,
	"./key-art-420.webp.png": 431,
	"./key-art-768.jpg": 432,
	"./key-art-768.webp": 433,
	"./key-art-768.webp.png": 434,
	"./key_art-1024-7.jpg": 435,
	"./key_art-1024.jpg": 436,
	"./key_art-1920-7.jpg": 437,
	"./key_art-1920.jpg": 438,
	"./key_art-320-7.jpg": 439,
	"./key_art-320.jpg": 440,
	"./key_art-768-7.jpg": 441,
	"./key_art-768.jpg": 442,
	"./key_art.png": 443,
	"./keyart_blocker_frame.png": 444,
	"./keyart_blocker_frame_bottom_pattern.png": 445,
	"./logo-footer.png": 446,
	"./logo.svg": 658,
	"./macha-icon.png": 447,
	"./macha-main-1024.jpg": 448,
	"./macha-main-1024.webp": 449,
	"./macha-main-1024.webp.png": 450,
	"./macha-main-1080.jpg": 451,
	"./macha-main-1080.webp": 452,
	"./macha-main-1080.webp.png": 453,
	"./macha-main-320.jpg": 454,
	"./macha-main-320.webp": 455,
	"./macha-main-320.webp.png": 456,
	"./macha-main-420.jpg": 457,
	"./macha-main-420.webp": 458,
	"./macha-main-420.webp.png": 459,
	"./macha-main-768.jpg": 460,
	"./macha-main-768.webp": 461,
	"./macha-main-768.webp.png": 462,
	"./macha-panel-1024.jpg": 463,
	"./macha-panel-1024.webp": 464,
	"./macha-panel-1024.webp.png": 465,
	"./macha-panel-1050.webp.png": 466,
	"./macha-panel-1080.jpg": 467,
	"./macha-panel-1080.webp": 468,
	"./macha-panel-1080.webp.png": 469,
	"./macha-panel-320.jpg": 470,
	"./macha-panel-320.webp": 471,
	"./macha-panel-320.webp.png": 472,
	"./macha-panel-420.jpg": 473,
	"./macha-panel-420.webp": 474,
	"./macha-panel-420.webp.png": 475,
	"./macha-panel-768.jpg": 476,
	"./macha-panel-768.webp": 477,
	"./macha-panel-768.webp.png": 478,
	"./nav_pattern.png": 479,
	"./ork-320.jpg": 480,
	"./ork-320.webp": 481,
	"./ork-320.webp.png": 482,
	"./ork-420.jpg": 483,
	"./ork-420.webp": 484,
	"./ork-420.webp.png": 485,
	"./ork-660.jpg": 486,
	"./ork-660.webp": 487,
	"./ork-660.webp.png": 488,
	"./orks-vignette-preview-320.jpg": 489,
	"./orks-vignette-preview-320.webp": 490,
	"./orks-vignette-preview-320.webp.png": 491,
	"./orks-vignette-preview-420.jpg": 492,
	"./orks-vignette-preview-420.webp": 493,
	"./orks-vignette-preview-420.webp.png": 494,
	"./orks-vignette-preview-460.jpg": 495,
	"./orks-vignette-preview-460.webp": 496,
	"./orks-vignette-preview-460.webp.png": 497,
	"./p28.png": 498,
	"./play-arrow.png": 499,
	"./post-img.png": 500,
	"./power_has_a_price-1024.jpg": 501,
	"./power_has_a_price-1024.webp": 502,
	"./power_has_a_price-1024.webp.png": 503,
	"./power_has_a_price-1050.jpg": 504,
	"./power_has_a_price-1050.webp": 505,
	"./power_has_a_price-1050.webp.png": 506,
	"./power_has_a_price-320.jpg": 507,
	"./power_has_a_price-320.webp": 508,
	"./power_has_a_price-320.webp.png": 509,
	"./power_has_a_price-420.jpg": 510,
	"./power_has_a_price-420.webp": 511,
	"./power_has_a_price-420.webp.png": 512,
	"./power_has_a_price-768.jpg": 513,
	"./power_has_a_price-768.webp": 514,
	"./power_has_a_price-768.webp.png": 515,
	"./privacy-certified-2.png": 516,
	"./psyker-blast-video-poster.jpg": 517,
	"./raw-key-art-1024.jpg": 518,
	"./raw-key-art-1920.jpg": 519,
	"./raw-key-art-320.jpg": 520,
	"./raw-key-art-768.jpg": 521,
	"./relic-footer-logo.png": 522,
	"./relic-footer-logo2.png": 523,
	"./retribution-video-poster.jpg": 524,
	"./retribution.png": 525,
	"./sega-footer-logo-lg-2.png": 526,
	"./sega-footer-logo-lg.png": 527,
	"./shadow_20x60.png": 528,
	"./singing-spear-video-poster.jpg": 529,
	"./skull-divider.png": 530,
	"./skull.png": 531,
	"./skull_divider.png": 532,
	"./sm-320.jpg": 533,
	"./sm-320.webp": 534,
	"./sm-320.webp.png": 535,
	"./sm-420.jpg": 536,
	"./sm-420.webp": 537,
	"./sm-420.webp.png": 538,
	"./sm-660.jpg": 539,
	"./sm-660.webp": 540,
	"./sm-660.webp.png": 541,
	"./spacemarines-vignette-preview-320.jpg": 542,
	"./spacemarines-vignette-preview-320.webp": 543,
	"./spacemarines-vignette-preview-320.webp.png": 544,
	"./spacemarines-vignette-preview-420.jpg": 545,
	"./spacemarines-vignette-preview-420.webp": 546,
	"./spacemarines-vignette-preview-420.webp.png": 547,
	"./spacemarines-vignette-preview-460.jpg": 548,
	"./spacemarines-vignette-preview-460.webp": 549,
	"./spacemarines-vignette-preview-460.webp.png": 550,
	"./spacemarines-vignette-preview.jpg": 551,
	"./spinnin-klaw-video-poster.jpg": 552,
	"./temporal-weave-video-poster.jpg": 553,
	"./trailer_preview-320.jpg": 554,
	"./trailer_preview-320.webp": 555,
	"./trailer_preview-320.webp.png": 556,
	"./trailer_preview-420.jpg": 557,
	"./trailer_preview-420.webp": 558,
	"./trailer_preview-420.webp.png": 559,
	"./trailer_preview-460.jpg": 560,
	"./trailer_preview-460.webp": 561,
	"./trailer_preview-460.webp.png": 562,
	"./unleash_giants_1-320.jpg": 563,
	"./unleash_giants_1-320.webp": 564,
	"./unleash_giants_1-320.webp.png": 565,
	"./unleash_giants_1-420.jpg": 566,
	"./unleash_giants_1-420.webp": 567,
	"./unleash_giants_1-420.webp.png": 568,
	"./unleash_giants_1-768.jpg": 569,
	"./unleash_giants_1-768.webp": 570,
	"./unleash_giants_1-768.webp.png": 571,
	"./unleash_giants_1-872.jpg": 572,
	"./unleash_giants_1-872.webp": 573,
	"./unleash_giants_1-872.webp.png": 574,
	"./unleash_giants_2-320.jpg": 575,
	"./unleash_giants_2-320.webp": 576,
	"./unleash_giants_2-320.webp.png": 577,
	"./unleash_giants_2-420.jpg": 578,
	"./unleash_giants_2-420.webp": 579,
	"./unleash_giants_2-420.webp.png": 580,
	"./unleash_giants_2-768.jpg": 581,
	"./unleash_giants_2-768.webp": 582,
	"./unleash_giants_2-768.webp.png": 583,
	"./unleash_giants_2-872.jpg": 584,
	"./unleash_giants_2-872.webp": 585,
	"./unleash_giants_2-872.webp.png": 586,
	"./unleash_giants_3-320.jpg": 587,
	"./unleash_giants_3-320.webp": 588,
	"./unleash_giants_3-320.webp.png": 589,
	"./unleash_giants_3-420.jpg": 590,
	"./unleash_giants_3-420.webp": 591,
	"./unleash_giants_3-420.webp.png": 592,
	"./unleash_giants_3-768.jpg": 593,
	"./unleash_giants_3-768.webp": 594,
	"./unleash_giants_3-768.webp.png": 595,
	"./unleash_giants_3-872.jpg": 596,
	"./unleash_giants_3-872.webp": 597,
	"./unleash_giants_3-872.webp.png": 598,
	"./unleash_titans-320.jpg": 599,
	"./unleash_titans-320.webp": 600,
	"./unleash_titans-320.webp.png": 601,
	"./unleash_titans-420.jpg": 602,
	"./unleash_titans-420.webp": 603,
	"./unleash_titans-420.webp.png": 604,
	"./unleash_titans-768.jpg": 605,
	"./unleash_titans-768.webp": 606,
	"./unleash_titans-768.webp.png": 607,
	"./unleash_titans-872.jpg": 608,
	"./unleash_titans-872.webp": 609,
	"./unleash_titans-872.webp.png": 610,
	"./war_has_a_price-1024.jpg": 611,
	"./war_has_a_price-1024.webp": 612,
	"./war_has_a_price-1024.webp.png": 613,
	"./war_has_a_price-1050.jpg": 614,
	"./war_has_a_price-1050.webp": 615,
	"./war_has_a_price-1050.webp.png": 616,
	"./war_has_a_price-320.jpg": 617,
	"./war_has_a_price-320.webp": 618,
	"./war_has_a_price-320.webp.png": 619,
	"./war_has_a_price-420.jpg": 620,
	"./war_has_a_price-420.webp": 621,
	"./war_has_a_price-420.webp.png": 622,
	"./war_has_a_price-768.jpg": 623,
	"./war_has_a_price-768.webp": 624,
	"./war_has_a_price-768.webp.png": 625
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;



//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img ^\.\/.*$
// module id = 77
// module chunks = 0